import { assert, IGNORED, Test } from "oc-e2e-testrunner";
import {
  assertWarnungen,
  createElement,
  createMauer,
  getInspiredArrangement,
  logPartBoxes,
  resetArrangement,
} from "./utils";
import { v2, v3 } from "oc-threejs/short3";
import * as Commons from "oc-commons/Commons";

export default {
  name: "TestFundament",
};

export const testMauerUndPfostenFundament: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;
  const configuration = {
    inspiration: "Inspiration SYSTEM WPC PLATINUM XL Taupe-Grau",
    zaunart: "Sichtschutz",
    serie: "SYSTEM",
    grundriss: {
      ecken: [
        {
          id: 3,
          punkt: {
            x: -5,
            y: 0,
          },
        },
        {
          id: 4,
          punkt: {
            x: 5,
            y: 0,
          },
        },
      ],
      kanten: [
        {
          ecken: [3, 4],
        },
      ],
    },
    segmente: [
      {
        breite: 10,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.845,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 0.02,
            füllungAuswahlwert: "SYSTEM WPC PLATINUM XL Taupe-Grau",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 5,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 0,
            isStandardMass: true,
            detailSerie: "SYSTEM WPC PLATINUM XL",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
            elementID: 0,
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
    ],
    ecken: [
      {
        position: {
          x: -5,
          y: 0,
          z: 0,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: -5,
            y: 0,
            z: 0,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Klemmpfosten",
          pfostenartAuswahlwertIndividualisiert: false,
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: 5,
          y: 0,
          z: 0,
        },
      },
    ],
    aufbauten: [
      {
        Key: "hyyd6j42cmoc",
        aufbauMeta: "Mauer",
        position: {
          x: -5.025,
          y: 0,
          z: -0.38,
        },
        size: {
          x: 0.91,
          y: 2,
          z: 0.5,
        },
        drehung: 0,
      },
    ],
    pfostenartAuswahlwert: "Klemmpfosten",
    pfostenfarbeAuswahlwert: "Anthrazit",
    bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
    elementhalterAuswahlwert: "2096 Elementhalter",
    verteilungsstrategieAuswahlwert: "Individuell",
    pageName: "Zauneditor",
  };
  agt.fromJSON(configuration);
  agt.update3d();
  assert.deepEquals(
    [
      {
        text: "Mauer kollidiert mit Fundament",
        box3OrOBB: {
          center: {
            x: -5,
            y: -0.3,
            z: 0,
          },
          halfSize: {
            x: 0.205,
            y: 0.305,
            z: 0.205,
          },
          rotation: [1, 0, 0, 0, 1, 0, 0, 0, 1],
        },
        positionYOffset: -1.6,
      },
    ],
    agt.warnungen.map((w) => ({
      text: w.text,
      box3OrOBB: w.box3OrOBB.toJSON(),
      positionYOffset: w.positionYOffset,
    })),
    "Warnung",
    0.001
  );
  assert.deepEqualsStringified(
    [
      {
        points: [
          {
            x: -0.2,
            y: -0.2,
          },
          {
            x: 0.2,
            y: -0.2,
          },
          {
            x: 0.2,
            y: 0.2,
          },
          {
            x: -0.2,
            y: 0.2,
          },
        ],
        tiefe: 0.6,
      },
      {
        points: [
          {
            x: -0.2,
            y: -0.2,
          },
          {
            x: 0.2,
            y: -0.2,
          },
          {
            x: 0.2,
            y: 0.2,
          },
          {
            x: -0.2,
            y: 0.2,
          },
        ],
        tiefe: 0.6,
      },
    ],
    agt.getFundamente().map((f) => ({
      points: f.points,
      tiefe: f.tiefe,
    })),
    "Fundamente",
    0.001
  );
};

export const testMauerUndSchiebetorFundament: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;
  const configuration = {
    inspiration: "Inspiration SYSTEM WPC PLATINUM XL Taupe-Grau",
    zaunart: "Sichtschutz",
    serie: "SYSTEM",
    grundriss: {
      ecken: [
        {
          id: 3,
          punkt: {
            x: -5,
            y: 0,
          },
        },
        {
          id: 4,
          punkt: {
            x: 5,
            y: 0,
          },
        },
      ],
      kanten: [
        {
          ecken: [3, 4],
        },
      ],
    },
    segmente: [
      {
        breite: 10,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 4,
            höhe: 1.8,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 0.05,
            füllungAuswahlwert: "SYSTEM WPC PLATINUM XL Taupe-Grau",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            rahmenAuswahlwert: "Schiebetor_Rahmen_Anthrazit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile_Mass_Tore_30cm",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            form: "Schiebetor",
            massAuswahlwert: "Schiebetor_Easy",
            profilPosition: 5,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 0,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC PLATINUM XL",
            anMauer: "AnMauer_nein",
            isMasstor: true,
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
            isEAntrieb: true,
            key: "3811 Schiebetor E-Antrieb SYSTEM WPC Platinum XL",
            lichteWeite: 4,
            hideRahmen: false,
            showProfilausrichtung: true,
            showAdapterleiste: true,
            hasAnschlagprofil: false,
            bestelllisteArtikel: ["3811_wpc_platinum"],
            artikelID: "3811_wpc_platinum",
            füllungName: "Füllung",
            ausrichtungCode: "eirb",
            pdf: {},
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 4.05,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwertIndividualisiert: false,
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
    ],
    ecken: [
      {
        position: {
          x: -5,
          y: 0,
          z: 0,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: -5,
            y: 0,
            z: 0,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwertIndividualisiert: false,
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: 5,
          y: 0,
          z: 0,
        },
      },
    ],
    aufbauten: [
      {
        Key: "hyyd6j42cmoc",
        aufbauMeta: "Mauer",
        position: {
          x: -5.025,
          y: 0,
          z: -0.6300000000000002,
        },
        size: {
          x: 0.91,
          y: 2,
          z: 0.5,
        },
        drehung: 0,
      },
    ],
    pfostenartAuswahlwert: "Klemmpfosten",
    pfostenfarbeAuswahlwert: "Anthrazit",
    bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
    elementhalterAuswahlwert: "Elementhalter Weiß",
    verteilungsstrategieAuswahlwert: "Individuell",
  };
  agt.fromJSON(configuration);
  agt.update3d();
  assert.deepEquals(
    [
      {
        text: "Mauer kollidiert mit Fundament",
        box3OrOBB: {
          center: {
            x: -5,
            y: -0.45,
            z: -0.515,
          },
          halfSize: {
            x: 0.63,
            y: 0.355,
            z: 0.63,
          },
          rotation: [1, 0, 0, 0, 1, 0, 0, 0, 1],
        },
        positionYOffset: -1.8,
      },
    ],
    agt.warnungen.map((w) => ({
      text: w.text,
      box3OrOBB: w.box3OrOBB.toJSON(),
      positionYOffset: w.positionYOffset,
    })),
    "Warnung",
    0.001
  );
  assert.deepEqualsStringified(
    [
      {
        points: [
          {
            x: -0.675,
            y: 0.2,
          },
          {
            x: 0.575,
            y: 0.2,
          },
          {
            x: 0.575,
            y: -1.05,
          },
          {
            x: -0.675,
            y: -1.05,
          },
        ],
        tiefe: 0.7,
      },
      {
        points: [
          {
            x: 3.8,
            y: 0.25,
          },
          {
            x: 6.138,
            y: 0.25,
          },
          {
            x: 6.138,
            y: -0.45,
          },
          {
            x: 5.2,
            y: -0.45,
          },
          {
            x: 5.2,
            y: -1.15,
          },
          {
            x: 3.8,
            y: -1.15,
          },
        ],
        tiefe: 0.7,
      },
      {
        points: [
          {
            x: 7.314,
            y: -0.25,
          },
          {
            x: 7.814,
            y: -0.25,
          },
          {
            x: 7.814,
            y: 0.25,
          },
          {
            x: 7.314,
            y: 0.25,
          },
        ],
        tiefe: 0.7,
      },
    ],
    agt.getFundamente().map((f) => ({
      points: f.points,
      tiefe: f.tiefe,
    })),
    "Fundamente",
    0.001
  );
};
